import React from 'react'
import { Box, Menu, MenuItem } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/pro-duotone-svg-icons/faTimes'
import { faRedo } from '@fortawesome/pro-duotone-svg-icons/faRedo'
import { faExpand } from '@fortawesome/pro-duotone-svg-icons/faExpand'
import { faPlus } from '@fortawesome/pro-duotone-svg-icons/faPlus'
import { faCaretDown } from '@fortawesome/pro-duotone-svg-icons/faCaretDown'

import BlockEditButton from './BlockEditButton'
import {
    StyledButton,
    CompactButton,
} from '@/Components/Elements/StyledComponents/Buttons'

export default class BlockToolbar extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            dateFormat: null,
            anchorEl: null,
        }
    }

    render() {
        const kedo = this.props.kedo

        return (
            <Box
                className={'kedo-block-toolbar'}
                sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    gap: 1,
                }}
            >
                <CompactButton
                    title={kedo.t('Hide')}
                    sx={{ float: 'right' }}
                    variant={'light'}
                    onClick={() => this.props.onClose(this.props.block.uuid)}
                    dense
                >
                    <FontAwesomeIcon icon={faTimes} />
                </CompactButton>
                {this.props.onMax ? (
                    <CompactButton
                        title={kedo.t('Maximize')}
                        sx={{ float: 'right' }}
                        variant={'light'}
                        onClick={() => this.props.onMax(this.props.block.uuid)}
                        dense
                    >
                        <FontAwesomeIcon icon={faExpand} />
                    </CompactButton>
                ) : null}
                {this.props.block &&
                this.props.block.settings?.use_creation_date ? (
                    <>
                        <StyledButton
                            variant="light"
                            title={kedo.t(this.state.dateFormat)}
                            id={`block-d-${this.props.block.id}`}
                            className={'kedo-block-filter'}
                            endIcon={
                                <FontAwesomeIcon icon={faCaretDown} size="sm" />
                            }
                            sx={{
                                float: 'right',
                                '& .MuiButton-endIcon svg ': {
                                    fontSize: '16px',
                                },
                            }}
                            onClick={(e) =>
                                this.setState({
                                    anchorEl: e.currentTarget,
                                })
                            }
                        >
                            {kedo.t(this.state.dateFormat)}
                        </StyledButton>
                        <Menu
                            variant={'light'}
                            title={kedo.t(this.state.dateFormat)}
                            id={`block-d-${this.props.block.id}`}
                            className={'kedo-block-filter'}
                        >
                            <MenuItem
                                onSelect={() =>
                                    this.setState(
                                        { dateFormat: 'year_month' },
                                        () =>
                                            this.props.setFilterAndFetchData(
                                                'dateFormat',
                                                'year_month'
                                            )
                                    )
                                }
                            >
                                {kedo.t('year_month')}
                            </MenuItem>
                            <MenuItem
                                onSelect={() =>
                                    this.setState(
                                        { dateFormat: 'quarter' },
                                        () =>
                                            this.props.setFilterAndFetchData(
                                                'dateFormat',
                                                'quarter'
                                            )
                                    )
                                }
                            >
                                {kedo.t('quarter')}
                            </MenuItem>
                            <MenuItem
                                onSelect={() =>
                                    this.setState({ dateFormat: 'year' }, () =>
                                        this.props.setFilterAndFetchData(
                                            'dateFormat',
                                            'year'
                                        )
                                    )
                                }
                            >
                                {kedo.t('year')}
                            </MenuItem>
                        </Menu>
                    </>
                ) : null}
                {this.props.fetchData ? (
                    <CompactButton
                        title={kedo.t('Refresh')}
                        variant={'light'}
                        sx={{ float: 'right' }}
                        className={'kedo-block-filter'}
                        onClick={() => this.props.fetchData()}
                        dense
                    >
                        <FontAwesomeIcon icon={faRedo} />
                    </CompactButton>
                ) : null}
                {kedo.isAdminOrEnvironmentAdmin() ? (
                    <BlockEditButton
                        item={this.props.block}
                        kedo={kedo}
                        onSuccess={() =>
                            this.props.onSuccess(this.props.block.id)
                        }
                    />
                ) : null}
            </Box>
        )
    }
}
